module.exports = __webpack_public_path__ + "img/frontend.aee614ba.png";